let store = {
  namespaced: true,
  state: {
    pageCurrentPlaying: false
  },
  mutations: {
    PLAY (state, payload) {
      state.pageCurrentPlaying = payload
    },
    PAUSE (state) {
      state.pageCurrentPlaying = false
    }
  },
  actions: {
  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/modules/soundclip.js